// Canonical artwork records. Home, shop, product, and gallery pages all read from here.
const UNCATEGORIZED = "uncategorized";

const collections = {
    hachioki: {
        collection: "hachioki",
        collectionJp: "はちおき",
        collectionName: "Hachioki",
    },
};

const definePiece = ({ file, folder, cropped = false, ...rest }) => {
    const galleryImage = `/images/${folder}/${file}`;
    const year = rest.year || rest.title?.match(/(\d{4})\s*$/)?.[1] || null;
    return {
        id: rest.id || file.replace(/\.[^.]+$/, ""),
        file,
        folder,
        year,
        galleryImage,
        image: cropped ? `/images/collection/${file}` : galleryImage,
        ...rest,
        collection: rest.collection || UNCATEGORIZED,
    };
};

const artPieces = [
    definePiece({
        file: "hachioki0.jpg",
        folder: "hachioki",
        shopOrder: 2,
        title: "hug",
        format: "sticker",
        detail: "Dimensions: 3\" x 2\"",
        category: "Sticker",
        price: 4,
        stock: 0,
        soldOut: true,
        summary: "A linocut of two figures holding each other in sticker form! Premium vinyl sticker perfect for laptops, water bottles, and outdoor use - waterproof, scratch-resistant, and dishwasher safe.",
        image: "/images/hachioki/hachioki0.jpg",
        images: [
            "/images/hachioki/hachioki0.jpg",
            "/images/hachioki/hachioki0-stickers.jpg",
        ],
        ...collections.hachioki,
    }),
    definePiece({
        file: "hachioki1.jpg",
        folder: "hachioki",
        shopOrder: 1,
        title: "kokeshikara",
        format: "sticker",
        detail: "Dimensions: 3\" x 3\"",
        category: "Sticker",
        price: 4,
        stock: 0,
        soldOut: true,
        summary: "Bouquet inspired by flowers from a kokeshi doll. Premium vinyl sticker perfect for laptops, water bottles, and outdoor use - waterproof, scratch-resistant, and dishwasher safe.",
        image: "/images/hachioki/hachioki1.jpg",
        images: [
            "/images/hachioki/hachioki1.jpg",
            "/images/hachioki/hachioki1-stickers.jpg",
        ],
        ...collections.hachioki,
    }),
    definePiece({
        file: "hachioki2.jpg",
        folder: "hachioki",
        shopOrder: 0,
        title: "sakurabana",
        format: "sticker",
        detail: "Dimensions: 2\" x 3\"",
        category: "Sticker",
        price: 4,
        stock: 0,
        soldOut: true,
        summary: "Cherry blossom relief print in sticker form! Premium vinyl sticker perfect for laptops, water bottles, and outdoor use - waterproof, scratch-resistant, and dishwasher safe.",
        image: "/images/hachioki/hachioki2.jpg",
        images: [
            "/images/hachioki/hachioki2.jpg",
            "/images/hachioki/hachioki2-stickers.jpg",
        ],
        ...collections.hachioki,
    }),
    definePiece({
        file: "screenprint0.jpg",
        folder: "screenprint",
        cropped: true,
        shopOrder: 23,
        title: "'japanese lotus' 2023",
        detail: "CMYK separation screenprint, interference ink 15\" x 22\"",
        category: "Screenprint",
        price: 95,
        edition: "Edition of 12",
        badge: "Best Seller",
        stock: 0,
        soldOut: true,
        summary: "A lotus rendered in CMYK with interference ink, shifting as the light moves across the sheet.",
    }),
    definePiece({
        file: "intaglio2.jpg",
        folder: "intaglio",
        shopOrder: 24,
        title: "'maybirds' 2023",
        detail: "intaglio, digital chine collé 10\" x 10\"",
        category: "Intaglio",
        price: 60,
        edition: "Edition of 10",
        badge: "Best Seller",
    }),
    definePiece({
        file: "relief7.jpg",
        folder: "relief",
        cropped: true,
        shopOrder: 25,
        title: "'four mile beach' 2023",
        detail: "8 layer mokuhanga, 8\" x 12\"",
        category: "Relief",
        price: 80,
        edition: "Edition of 8",
        badge: "Best Seller",
        summary: "An eight-layer mokuhanga of Four Mile Beach — carved and printed by hand in the Japanese woodcut tradition.",
    }),
    definePiece({
        file: "litho2.jpg",
        folder: "litho",
        cropped: true,
        shopOrder: 3,
        title: "'reaching-out' 2022",
        detail: "a study on Autumn Flowers by Tomioka Tessai — lithograph, 15\" x 22\"",
        category: "Lithography",
        price: 85,
        edition: "Edition of 10",
        summary: "A lithographic study after Tomioka Tessai’s Autumn Flowers, drawn stone to paper.",
    }),
    definePiece({
        file: "litho0.jpg",
        folder: "litho",
        shopOrder: 4,
        title: "'banana slug' 2022",
        detail: "lithograph, 8\" x 10\"",
        category: "Lithography",
        price: 40,
        edition: "Edition of 15",
    }),
    definePiece({
        file: "litho1.jpg",
        folder: "litho",
        shopOrder: 5,
        title: "'sama' 2022",
        detail: "a study on La Samaritaine by Alphonse Mucha — lithograph, 8\" x 17\"",
        category: "Lithography",
        price: 65,
        edition: "Edition of 10",
    }),
    definePiece({
        file: "litho3.jpg",
        folder: "litho",
        shopOrder: 6,
        title: "'one-leg quail' 2022",
        detail: "lithograph, 8\" x 10\"",
        category: "Lithography",
        price: 40,
        edition: "Edition of 15",
        soldOut: true,
    }),
    definePiece({
        file: "screenprint1.jpg",
        folder: "screenprint",
        cropped: true,
        shopOrder: 7,
        title: "'mandarin' 2023",
        detail: "four color screenprint, 15\" x 22\"",
        category: "Screenprint",
        price: 75,
        edition: "Edition of 12",
        summary: "Four transparent layers of ink built into a single citrus form — bright, flat, and exact.",
    }),
    definePiece({
        file: "intaglio0.jpg",
        folder: "intaglio",
        shopOrder: 8,
        title: "'the wharf' 2023",
        detail: "photogravure, digital chine collé 10\" x 12\"",
        category: "Intaglio",
        price: 70,
        edition: "Edition of 10",
    }),
    definePiece({
        file: "intaglio1.jpg",
        folder: "intaglio",
        title: "'the wharf' 2023",
        detail: "photogravure 10\" x 12\"",
        category: "Intaglio",
        edition: "Edition of 10",
    }),
    definePiece({
        file: "intaglio5.jpg",
        folder: "intaglio",
        shopOrder: 9,
        title: "'shoreline' 2023",
        detail: "photogravure, digital chine collé 10\" x 12\"",
        category: "Intaglio",
        price: 70,
        edition: "Edition of 10",
    }),
    definePiece({
        file: "intaglio3.jpg",
        folder: "intaglio",
        shopOrder: 10,
        title: "'rising of three green moons' 2023",
        detail: "photogravure, digital chine collé 30\" x 22\"",
        category: "Intaglio",
        price: 150,
        edition: "Edition of 5",
    }),
    definePiece({
        file: "intaglio4.jpg",
        folder: "intaglio",
        shopOrder: 11,
        title: "'green going through' 2023",
        detail: "photogravure, 30\" x 22\"",
        category: "Intaglio",
        price: 140,
        edition: "Edition of 5",
        soldOut: true,
    }),
    definePiece({
        file: "intaglio6.jpg",
        folder: "intaglio",
        title: "'rising of three green moons (I)' 2023",
        detail: "photogravure, 8\" x 17\"",
        category: "Intaglio",
        edition: "Edition of 5",
    }),
    definePiece({
        file: "intaglio7.jpg",
        folder: "intaglio",
        title: "'rising of three green moons (II)' 2023",
        detail: "photogravure, 8\" x 17\"",
        category: "Intaglio",
        edition: "Edition of 5",
    }),
    definePiece({
        file: "intaglio8.jpg",
        folder: "intaglio",
        title: "'green going through (I)' 2023",
        detail: "photogravure, 8\" x 17\"",
        category: "Intaglio",
        edition: "Edition of 5",
    }),
    definePiece({
        file: "intaglio9.jpg",
        folder: "intaglio",
        title: "'green going through (III)' 2023",
        detail: "photogravure, 8\" x 17\"",
        category: "Intaglio",
        edition: "Edition of 5",
    }),
    definePiece({
        file: "relief1.jpg",
        folder: "relief",
        cropped: true,
        shopOrder: 12,
        title: "'synthesis' (heaven pattern 1) 2023",
        detail: "woodcut, 25\" x 25\"",
        category: "Relief",
        price: 120,
        edition: "Edition of 6",
        summary: "The first of the heaven-pattern woodcuts — a repeating celestial motif cut from a single block.",
    }),
    definePiece({
        file: "relief2.jpg",
        folder: "relief",
        cropped: true,
        shopOrder: 13,
        title: "'circulation' (gingko pattern 2) 2023",
        detail: "woodcut, 25\" x 25\"",
        category: "Relief",
        price: 120,
        edition: "Edition of 6",
        summary: "Ginkgo leaves in circulation — a companion woodcut to the heaven pattern, printed 25 inches square.",
    }),
    definePiece({
        file: "relief3.jpg",
        folder: "relief",
        shopOrder: 14,
        title: "'tongues' (penstemon pattern 3) 2023",
        detail: "woodcut, 40\" x 26\"",
        category: "Relief",
        price: 160,
        edition: "Edition of 4",
    }),
    definePiece({
        file: "relief4.jpg",
        folder: "relief",
        shopOrder: 15,
        title: "'heaven on earth' 2023",
        detail: "relief woodcut, 15\" x 22\"",
        category: "Relief",
        price: 90,
        edition: "Edition of 8",
    }),
    definePiece({
        file: "relief5.jpg",
        folder: "relief",
        shopOrder: 16,
        title: "'bingsu' 2021",
        detail: "linocut, 10\" x 12\"",
        category: "Relief",
        price: 45,
        edition: "Edition of 20",
    }),
    definePiece({
        file: "relief6.jpg",
        folder: "relief",
        cropped: true,
        shopOrder: 17,
        title: "'kiku ocean' 2023",
        detail: "woodcut, 6\" x 8\"",
        category: "Relief",
        price: 20,
        edition: "Edition of 20",
        stock: 0,
        soldOut: true,
        summary: "Chrysanthemum as current — a small woodcut meant to be lived with up close.",
    }),
    definePiece({
        file: "ecoprint5.jpg",
        folder: "ecoprint",
        cropped: true,
        shopOrder: 18,
        title: "'nanten' 2024",
        detail: "cyanotype, 6\" x 8\"",
        category: "Eco Print",
        price: 30,
        edition: "One of a kind",
        summary: "Nandina exposed in sunlight on treated paper — a unique cyanotype, not an edition.",
    }),
    definePiece({
        file: "ecoprint4.jpg",
        folder: "ecoprint",
        shopOrder: 19,
        title: "'untitled' 2023",
        detail: "wisteria, poppy, + rosemary ecoprint 6\" x 8\"",
        category: "Eco Print",
        price: 35,
        edition: "One of a kind",
    }),
    definePiece({
        file: "ecoprint1.jpg",
        folder: "ecoprint",
        shopOrder: 20,
        title: "'untitled' 2023",
        detail: "yarrow + lavender ecoprint 6\" x 22\"",
        category: "Eco Print",
        price: 45,
        edition: "One of a kind",
    }),
    definePiece({
        file: "ecoprint0.jpg",
        folder: "ecoprint",
        title: "'untitled' 2023",
        detail: "rosemary, clover, + lavender ecoprint 4\" x 22\"",
        category: "Eco Print",
        edition: "One of a kind",
    }),
    definePiece({
        file: "ecoprint2.jpg",
        folder: "ecoprint",
        shopOrder: 21,
        title: "'untitled' 2023",
        detail: "californian poppy + daisy ecoprint 8\" x 10\"",
        category: "Eco Print",
        price: 40,
        edition: "One of a kind",
        soldOut: true,
    }),
    definePiece({
        file: "ecoprint3.jpg",
        folder: "ecoprint",
        shopOrder: 22,
        title: "'untitled' 2023",
        detail: "japanese maple + lavender ecoprint 6\" x 8\"",
        category: "Eco Print",
        price: 35,
        edition: "One of a kind",
    }),
];

export const pieceCaption = (piece) => ({
    Title: piece.title,
    Body: [piece.detail, piece.edition].filter(Boolean).join("\n"),
});

const galleryOrder = [
    "litho2.jpg", "litho0.jpg", "litho1.jpg", "litho3.jpg",
    "intaglio1.jpg", "intaglio0.jpg", "intaglio2.jpg", "intaglio5.jpg",
    "intaglio3.jpg", "intaglio4.jpg", "intaglio6.jpg", "intaglio7.jpg",
    "intaglio8.jpg", "intaglio9.jpg",
    "screenprint0.jpg", "screenprint1.jpg",
    "ecoprint5.jpg", "ecoprint4.jpg", "ecoprint1.jpg", "ecoprint0.jpg",
    "ecoprint2.jpg", "ecoprint3.jpg",
    "relief1.jpg", "relief2.jpg", "relief3.jpg", "relief4.jpg",
    "relief5.jpg", "relief6.jpg", "relief7.jpg",
];

const imageDescription = Object.fromEntries(
    galleryOrder.map((file) => {
        const piece = artPieces.find((entry) => entry.file === file);
        return [file, pieceCaption(piece)];
    })
);

const featuredHome = artPieces.find((piece) => piece.id === "intaglio2");
const homeImage = featuredHome
    ? { [featuredHome.file]: pieceCaption(featuredHome) }
    : {};

const isShopItem = (piece) =>
    Boolean(piece) && (
        piece.collection === "hachioki"
        || piece.id === "screenprint0"
        || piece.id === "relief6"
    );

const shopItems = artPieces
    .filter(isShopItem)
    .sort((a, b) => a.shopOrder - b.shopOrder);

const shopCategories = [
    "All",
    ...(shopItems.some((item) => item.format === "sticker") ? ["Sticker"] : []),
    ...new Set(shopItems.filter((item) => item.format !== "sticker").map((item) => item.category)),
];

const shopFaq = [
    {
        question: "What is the return policy?",
        answer: "Because every print is handmade in a small edition (or one of a kind), we do not accept returns or exchanges. If your print arrives damaged, contact us within 7 days of delivery and we'll make it right.",
    },
    {
        question: "When will I get my order?",
        answer: "All orders ship out every Friday. Prints are shipped flat or rolled in an archival tube depending on size, and typically arrive within 3–5 business days after shipment.",
    },
    {
        question: "Do you ship internationally?",
        answer: "We currently ship within the United States only. Ground shipping is $8, or free on orders over $50.",
    },
    {
        question: "How should I care for my print?",
        answer: "Keep prints out of direct sunlight and frame behind UV-protective glass when possible. All prints are made on archival paper with lightfast inks.",
    },
    {
        question: "Where are the prints made?",
        answer: "Everything is hand-printed by Delaney Stewart at Print House Beko in Santa Cruz, California.",
    },
];

export { artPieces, shopItems, shopCategories, shopFaq, imageDescription, homeImage, galleryOrder, UNCATEGORIZED, collections, isShopItem };

export const hasNamedCollection = (item) =>
    Boolean(item?.collection && item.collection !== UNCATEGORIZED);

export const collectionLabel = (item) => {
    if (!hasNamedCollection(item)) {
        return null;
    }
    return item.collectionName || null;
};

export const groupItemsByCollection = (items) => {
    const named = new Map();
    const uncategorized = [];

    items.forEach((item) => {
        if (!hasNamedCollection(item)) {
            uncategorized.push(item);
            return;
        }
        if (!named.has(item.collection)) {
            named.set(item.collection, {
                id: item.collection,
                name: item.collectionName || item.collection,
                jp: item.collectionJp || null,
                items: [],
            });
        }
        named.get(item.collection).items.push(item);
    });

    return {
        groups: Array.from(named.values()),
        uncategorized,
    };
};

export const hachiokiItems = shopItems.filter((item) => item.collection === "hachioki");

export const featuredItems = shopItems.filter((item) => item.featured);

export const getShopItem = (id) => shopItems.find((item) => item.id === id);

export const getArtPiece = (id) => artPieces.find((piece) => piece.id === id);

export const getArtPieceByFile = (file) => artPieces.find((piece) => piece.file === file);

const smallWords = new Set(["of", "and", "the", "a", "an", "in", "on", "to", "for"]);

export const displayTitle = (title = "") => {
    const stripped = title.replace(/[''""]/g, "").trim();
    return stripped.replace(/[A-Za-z]+/g, (word, offset) => {
        const lower = word.toLowerCase();
        if (offset > 0 && smallWords.has(lower)) {
            return lower;
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
};

export const pieceName = (item, { shop = false } = {}) => {
    const formatted = displayTitle(item?.title);
    const year = item?.year || formatted.match(/\s(\d{4})$/)?.[1] || null;
    let name = year ? formatted.replace(/\s\d{4}$/, "").trim() : formatted;
    if (shop && item?.format && !name.toLowerCase().endsWith(item.format.toLowerCase())) {
        name = `${name} ${item.format.charAt(0).toUpperCase()}${item.format.slice(1)}`;
    }
    return { name, year, formatted };
};
